import { useEffect } from "react";
import qs from "qs";

import { CartDeal, CartDealGroup } from "custom-types/Cart";
import { useEventTracker } from "hooks/useEventTracker";
import { useSelector } from "redux/hooks";
import { getMenuLink } from "redux/selectors/cartDispensary";

import OfferCard from "components/OfferCard";

import CartItemContainer from "../CartItemContainer";

type Props = {
  groups: CartDealGroup[];
  isEmbedded?: boolean;
  embeddedMenuUrl?: string;
  embeddedQuery?: string;
};

const dealFilters = (deal: CartDeal | null, isEmbedded?: boolean) => {
  const title = deal && deal.title;

  return (
    (title &&
      `?${qs.stringify(
        isEmbedded
          ? { filter: { deal_title: [title] } }
          : { deal_title: [title] },
        { arrayFormat: "brackets", indices: false },
      )}`) ||
    ""
  );
};

const DealGroupContainer = ({
  groups,
  isEmbedded,
  embeddedMenuUrl,
  embeddedQuery,
}: Props) => {
  const menuLink = useSelector(getMenuLink);
  const { publishEvent } = useEventTracker();

  useEffect(() => {
    const hasIncompleteBOGO = groups.some(
      (group) => !!group.deal?.progress && group.deal.progress < 1,
    );

    if (hasIncompleteBOGO) {
      publishEvent({
        action: "impression",
        category: "Bag",
        label: "BOGO nudge",
        nonInteractionEvent: true,
      });
    }
  }, [groups]);

  return (
    <>
      {groups.map((group, i) => {
        const { deal, cartItems } = group;
        const dealLink = `${
          isEmbedded ? embeddedMenuUrl : `${menuLink}/menu`
        }${dealFilters(group.deal, isEmbedded)}${
          isEmbedded ? `&${embeddedQuery}` : ""
        }`;
        return deal ? (
          <div
            data-testid="deal-group-container"
            className="flex flex-col gap-4"
            key={i}
          >
            <OfferCard
              label={deal.title ?? ""}
              subLabel={
                deal.progress !== 1.0 ? (
                  <span>
                    {deal.progressText}{" "}
                    <a className="underline" href={dealLink}>
                      Shop eligible items
                    </a>
                  </span>
                ) : (
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
                  (null as any)
                )
              }
              progress={deal.progress ?? 0}
              progressText={deal.progressText ?? ""}
            />
            <CartItemContainer items={cartItems} isEmbedded={isEmbedded} />
          </div>
        ) : (
          <CartItemContainer
            items={cartItems}
            key={i}
            isEmbedded={isEmbedded}
          />
        );
      })}
    </>
  );
};

export default DealGroupContainer;
